import { gql, useQuery } from '@apollo/client';
import { useRouter } from 'next/router';

export const useStrapiMenu = (slug: string, locale: string) => {
  const GET_MENU = gql`
    query RenderNaviagtion($name: String!, $locale: I18NLocaleCode) {
      renderNavigation(navigationIdOrSlug: $name, locale: $locale, type: TREE) {
        path
        title
        parent {
          path
        }
        items {
          title
          path
        }
      }
    }
  `;

  const { data } = useQuery(GET_MENU, {
    variables: { name: slug, locale },
  });

  return data?.renderNavigation;
};
